import React from 'react';
import BaseIntroSetup from '../../../common/screens/baseIntroSetup';

const IntroSetup = (props) => (
  <BaseIntroSetup
    title={ <>Great news! Now you can earn cash back and use PayPal in stores</> }
    { ...props }
  />
);

export default IntroSetup;
